export const AFISHA_BASE_API_URL = 'https://api.pinsk.eu/afisha/v2/';
export const REQUEST_TIMEOUT_SECONDS: number = 20 * 1000;
